import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Category } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class CategoryService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getCategory(
    id,
    schema: any = {
      id: null,
      name: null,
      type: null,
      color: null,
      externalId: null,
    }
  ): Promise<Category> {
    return new Category(await this.core.services.category.getById(id, schema))
  }

  // todo basic params a schema pro entity vkladat na tech mistech nebo tady jako basic ?
  async getCategories(
    parameters: any = { direction: 'ASC', filters: { hasParent: false } },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: [{ id: null }]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.category.getList(parameters, schema)
  }

  createCategory(category: Partial<Category>, schema: any): Promise<Category> {
    return this.core.services.category.create(category, schema)
  }

  updateCategory(category: Partial<Category>, schema: any): Promise<Category> {
    return this.core.services.category.update(category, schema)
  }

  deleteCategory(category: Partial<Category>): Promise<Category> {
    return this.core.services.category.delete(category)
  }
}
